import Firebase from 'firebase'


export const db = Firebase
.initializeApp({
    apiKey: "AIzaSyAS_axE9TGYvec-zdP9YtUISkDb9zDNj2U",
    authDomain: "codeforces-2313e.firebaseapp.com",
    databaseURL: "https://codeforces-2313e-default-rtdb.firebaseio.com",
    projectId: "codeforces-2313e",
    storageBucket: "codeforces-2313e.appspot.com",
    messagingSenderId: "598529410512",
    appId: "1:598529410512:web:fa3b39c89cf31af3c4a5d5",
    measurementId: "G-3BEWKZ6FWD"
  })
.database()

export const viewRef = db.ref("views/views");